export default __webpack_public_path__ + "static/media/IMG_20230720_075124_829.3867460b.jpg";